import { render, staticRenderFns } from "./MailServerLIst.vue?vue&type=template&id=0b302d27&scoped=true"
import script from "./MailServerLIst.vue?vue&type=script&lang=js"
export * from "./MailServerLIst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b302d27",
  null
  
)

export default component.exports